import { FlagEnum } from '../models/flags'

export const FLAG_TEXT_COLOR = 'white'
export const FLAG_STROKE_WIDTH = 2
export const FLAG_STROKE_WIDTH_DESELECTED = 0

export const FLAG_COLORS = {
    [FlagEnum.TASK]: {
        color: '#B54708',
        hoverColor: '#7A2E0E',
        borderColor: '#DC6803',
    },
    [FlagEnum.NOTE]: {
        color: '#1D6BCD',
        hoverColor: '#1858A8',
        borderColor: '#5797E7',
    },
    [FlagEnum.CFB]: {
        color: '#198402',
        hoverColor: '#125E01',
        borderColor: '#479D35',
    },
    TEMPORARY: {
        fill: 'white',
        stroke: '#DC6803',
        textColor: '#3E4041',
    },
} as const
